import { i18n } from 'i18next'

import { formatNumber } from './formatNumber'

const BYTE_UNITS = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

export const formatBytes = (bytes: number, { i18n }: { i18n: i18n }) => {
    let number = bytes

    if (number === 0) {
        return ` 0 ${BYTE_UNITS[0]}`
    }

    const isNegative = number < 0
    const prefix = isNegative ? '-' : ''

    if (isNegative) {
        number = -number
    }

    if (number < 1) {
        const numberString = formatNumber(number, { format: 'int', i18n })
        return `${prefix + numberString} ${BYTE_UNITS[0]}`
    }

    const exponent = Math.min(Math.floor(Math.log10(number) / 3), BYTE_UNITS.length - 1)
    // eslint-disable-next-line
    number = Number((number / Math.pow(1024, exponent)).toPrecision(3))
    const numberString = formatNumber(number, { format: 'int', i18n })

    const unit = BYTE_UNITS[exponent]

    return `${prefix + numberString} ${unit}`
}
